const BooleanAttribute = (values, { name }) => {
  const {
    attributeId, isCustomDescription, description, value, ...rest
  } = values

  const isCustomName = rest.isCustomName === 'true'

  const config = {
    ...rest,
    isCustomName,
    ...!isCustomName && { name },
    description: isCustomDescription ? description : '',
    value: value === 'true'
  }
  return config
}

export default BooleanAttribute
